export { ConfirmForgotPassword } from './confirm-forgot-password';
